module.exports = __webpack_public_path__ + "media/newstyle/images/close-98b8740cc4f286c468c17cd211ac7490.svg";